import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Analysis } from 'src/app/analyses/interfaces/analyses.types';
import {
  AncestryQuestionnaireAnswered,
  AncestryResult,
  ChromosomePainting,
  EthnicityEstimate,
  Haplogroups,
  NeanderthalIntrogression,
  PhysicalTraits,
} from '../ancestry.interface';

@Injectable({ providedIn: 'root' })
export class AncestryApiService {
  constructor(private http: HttpClient) {}

  fetchAncestryResults(): Observable<AncestryResult> {
    return this.http.get<AncestryResult>(`/api/ancestry/results`);
  }

  fetchEthnicityEstimate(analysisId: string): Observable<EthnicityEstimate> {
    return this.http.get<EthnicityEstimate>(
      `/api/ancestry/results/ethnicity-estimate/${analysisId}`
    );
  }

  fetchChromosomePainting(analysisId: string): Observable<ChromosomePainting> {
    return this.http.get<ChromosomePainting>(
      `/api/ancestry/results/chromosome-painting/${analysisId}`
    );
  }

  fetchHaplogroups(analysisId: string): Observable<Haplogroups> {
    return this.http.get<Haplogroups>(
      `/api/ancestry/results/mathernal-haplogroup/${analysisId}`
    );
  }

  fetchNeanderthalIntrogression(
    analysisId: string
  ): Observable<NeanderthalIntrogression> {
    return this.http.get<NeanderthalIntrogression>(
      `/api/ancestry/results/neanderthal-introgression/${analysisId}`
    );
  }

  fetchPhysicalTraits(
    productInventoryItemId: string
  ): Observable<PhysicalTraits[]> {
    return this.http.get<PhysicalTraits[]>(
      `/api/dna/analyses/${productInventoryItemId}`
    );
  }

  fetchPhysicalTraitAnalysis(analysisId: string): Observable<Analysis> {
    return this.http.get<Analysis>(`/api/dna/analyses/${analysisId}/result`);
  }

  getUserAnswered(): Observable<AncestryQuestionnaireAnswered> {
    return this.http.get<AncestryQuestionnaireAnswered>(
      `/api/ancestry/questionnaire`
    );
  }

  saveQuestionnaire(id: string): Observable<void> {
    return this.http.post<any>(`/api/ancestry/questionnaire`, {
      submissionId: id,
    });
  }

  skipQuestionnaire(): Observable<void> {
    return this.http.post<any>(`/api/ancestry/questionnaire/skip`, {});
  }
}
